type AppConfig = {
  apiBaseUrl: string;
  // 인증 서버(overlord) 공개 URL. GitHub 로그인과 MCP 연결 코드(OTP) 발급 요청만 이 주소로 보낸다.
  // 인증 서버는 registry 와 다른 호스트의 별도 서비스다. 그래서 apiBaseUrl에서 파생하지 않는다.
  // 빈 문자열이면 로그인을 시작하지 않고 미설정을 알린다(`authClient`).
  authBaseUrl: string;
  // MCP 게이트웨이 공개 URL. registry API와 별도 Deployment다. 그래서 apiBaseUrl에서 파생하지 않는다.
  // 빈 문자열이면 연결 안내가 명령 대신 미설정 상태를 보여준다.
  mcpUrl: string;
  // 개발 환경 표준 지연 주입(rules.md §7). null이면 어떤 요청에도 지연을 넣지 않는다.
  simulatedLatencyMs: number | null;
  // 이 번들의 빌드 식별자(`g<sha>`). 배포된 `build-info.json` 과 비교해 번들이 오래되었는지 판정한다.
  buildId: string;
};

// 미국 <-> 한국/동남아 round-trip 표준(약 200ms ~ 300ms)의 중앙값을 기본 지연으로 둔다.
const STANDARD_LATENCY_MS = 250;

export const appConfig: AppConfig = {
  apiBaseUrl: normalizeBaseUrl(import.meta.env.VITE_API_BASE_URL),
  authBaseUrl: normalizeBaseUrl(import.meta.env.VITE_AUTH_BASE_URL),
  mcpUrl: normalizeBaseUrl(import.meta.env.VITE_MCP_URL),
  simulatedLatencyMs: resolveSimulatedLatencyMs(import.meta.env.VITE_SIMULATED_LATENCY),
  buildId: __APP_BUILD_ID__,
};

function normalizeBaseUrl(value: string | undefined): string {
  return readEnv(value).replace(/\/+$/, "");
}

function resolveSimulatedLatencyMs(value: string | undefined): number | null {
  // 시뮬레이션 지연은 개발 도구다. 프로덕션 빌드에서는 값과 관계없이 주입하지 않는다.
  if (!import.meta.env.DEV) {
    return null;
  }

  const raw = readEnv(value).toLowerCase();
  if (raw === "off" || raw === "0" || raw === "false") {
    return null;
  }

  // 값이 숫자면 그 값을 표준 지연(ms)으로 사용한다.
  if (raw !== "") {
    const parsed = Number(raw);
    if (Number.isFinite(parsed) && parsed >= 0) {
      return parsed;
    }
  }

  // 값이 없으면 개발 빌드에서 표준 round-trip 지연을 기본 적용한다.
  return STANDARD_LATENCY_MS;
}

function readEnv(value: string | undefined): string {
  return value?.trim() ?? "";
}
